import config from '@adc/configment'
import fetch from '@adc/fetch'

/**
 * Fetches values from user's current access_token.
 * "/tokenValues" is an express route defined in this app.
 *
 * @param {Object|null} req - Express request object
 */
export const fetchTokenValues = req =>
  fetch(`${config.get('URL_BASE_PREFIX')}/tokenValues`).then(res => {
    return res.body
  })
